<template>
  <div class="bgfff out_wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="支付中" name="1">
        <div class="flex1">
          <el-form :model="queryForm" label-width="92px" label-suffix=":">
            <div class="form-box">
              <el-form-item label="APPID" class="formItem">
                <el-select v-model="queryForm.appid" clearable filterable placeholder="请选择">
                  <el-option label="全部" value="" />
                  <el-option v-for="(item, index) in appidArr" :key="index" :label="item.appid" :value="item.appid">
                    <span>{{ item.appid }}</span><span class="ml5" style="color:#1482f0;">({{ item.app_name }})</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="formItem" label="创建时间">
                <el-date-picker
                  v-model="queryForm.query_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :clearable="true"
                  :editable="false"
                  @change="queryList"
                />
              </el-form-item>
              <template v-if="showMoreSearch">
                <el-form-item label="提现金额" class="formItem">
                  <price-range :obj="queryForm" @PChange="queryForm = {...$event}" />
                </el-form-item>
                <el-form-item label="客户订单号" class="formItem">
                  <el-input v-model="queryForm.order_id" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="OPENID" class="formItem">
                  <el-input v-model="queryForm.openid" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="状态" class="formItem">
                  <el-select v-model="queryForm.pay_status" placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="待支付" value="1" />
                    <el-option label="支付中" value="-1" />
                  </el-select>
                </el-form-item>
              <!-- <el-form-item>
                <el-button type="primary" @click="queryList">查询</el-button>
              </el-form-item> -->
              </template>
              <div class="formItem operate">
                <div>
                  <el-button type="primary" @click="queryList">查询</el-button>
                  <el-button @click="resetForm">重置</el-button>
                </div>
                <div class="more ml10 pointer" @click="showMoreSearch = !showMoreSearch">
                  <i :class="showMoreSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                  <span class="ml5">{{ showMoreSearch ? '收起' : '展开' }}</span>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <zf-table
          :columns="column"
          :data-source="tableData"
          :total="queryForm.total"
          :page-size="queryForm.pageSize"
          :page-num="queryForm.page"
          @change="handlePageChange"
        >
          <!-- 提现金额 -->
          <template
            slot="pay_amount"
            slot-scope="{ row }"
          >
            <span>￥{{ $formatCurrency(row.pay_amount) }}</span>
          </template>
          <!-- 状态 -->
          <template
            slot="pay_status"
            slot-scope="{ row }"
          >
            <span v-if="row.pay_status === 1" class="wait_bg plub_width inline">待支付</span>
            <span v-if="row.pay_status === -1" class="conduct_bg plub_width inline">支付中</span>
          </template>
        </zf-table>
      </el-tab-pane>
      <el-tab-pane label="已完成" name="2">
        <UseGuide class="mb20">
          <div>1.每天12:30生成昨日订单压缩包。</div>
          <div>2.每日压缩包导出后解压，重命名文件添加文件后缀名.csv后方可excel打开。</div>
        </UseGuide>
        <div class="flex1">
          <el-form :model="queryFormPaid" label-width="92px" label-suffix=":">
            <div class="form-box">
              <el-form-item label="APPID" class="formItem">
                <el-select v-model="queryFormPaid.appid" clearable filterable placeholder="请选择">
                  <el-option label="全部" value="" />
                  <el-option v-for="(item, index) in appidArr" :key="index" :label="item.appid" :value="item.appid">
                    <span>{{ item.appid }}</span><span style="color:#1482f0;">({{ item.app_name }})</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商户号" class="formItem">
                <el-select v-model="queryFormPaid.mch_id" clearable placeholder="请选择">
                  <el-option label="全部" value="" />
                  <el-option v-for="(item,index) in mchArr" :key="index" :label="item" :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="OPENID" class="formItem">
                <el-input v-model="queryFormPaid.openid" placeholder="请输入" />
              </el-form-item>
              <el-form-item class="formItem" label="创建时间">
                <el-date-picker
                  v-model="queryFormPaid.query_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  :editable="false"
                  @change="queryPaidList"
                />
              </el-form-item>
              <el-form-item label="客户订单号" class="formItem">
                <el-input v-model="queryFormPaid.order_id" placeholder="请输入" />
              </el-form-item>
              <template v-if="showMoreSearchList">
                <el-form-item label="平台订单号" class="formItem">
                  <el-input v-model="queryFormPaid.trade_no" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="状态" class="formItem">
                  <el-select v-model="queryFormPaid.pay_status" placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="支付成功" value="3" />
                    <el-option label="支付失败" value="4" />
                  </el-select>
                </el-form-item>
                <el-form-item label="提现金额" class="formItem">
                  <price-range :obj="queryFormPaid" @PChange="queryFormPaid = {...$event}" />
                </el-form-item>
              </template>
              <div class="formItem operate">
                <div>
                  <el-button type="primary" @click="queryPaidList">查询</el-button>
                  <el-button @click="resetPaid">重置</el-button>
                  <el-button v-if="exportShow" type="primary" @click="exportList">每日压缩包导出</el-button>
                </div>
                <div class="more ml10 pointer" @click="showMoreSearchList = !showMoreSearchList">
                  <i :class=" showMoreSearchList ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                  <span class="ml5">{{ showMoreSearchList ? '收起' : '展开' }}</span>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="total_box flex mb20">
          <div class="mr20">成功金额：<span class="active_color">￥{{ $formatCurrency(summaryPaid.success_sum) || '0.00' }}</span></div>
          <div class="mr20">失败金额：<span class="active_color">￥{{ $formatCurrency(summaryPaid.fail_sum) || '0.00' }}</span></div>
        </div>
        <zf-table
          :columns="paidListColumn"
          :data-source="list"
          :total="queryFormPaid.total"
          :page-size="queryFormPaid.pageSize"
          :page-num="queryFormPaid.page"
          @change="handlePageChangePaid"
        >
          <!-- 提现金额 -->
          <template
            slot="pay_amount"
            slot-scope="{ row }"
          >
            <span>￥{{ $formatCurrency(row.pay_amount) }}<a v-if="row.is_tax === 1 && row.received_price !== row.pay_amount" class="active_color ml5 pointer" @click="getTaxDetail(row)">税</a></span>
          </template>
          <!-- 状态 -->
          <template
            slot="pay_status"
            slot-scope="{ row }"
          >
            <span v-if="row.pay_status === 3" class="ableuse_bg plub_width inline">成功</span>
            <span v-if="row.pay_status === 4" class="plub_width nouse_bg inline">失败</span>
          </template>
        </zf-table>
      </el-tab-pane>
      <el-dialog
        title="预扣税信息"
        :visible.sync="visibleTaxDetail"
        width="450px"
        left
      >
        <div class="verify_box">
          <div class="item flex_middle"><i class="el-input__icon el-icon-link" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">平台订单号：</span><span class="flex1">{{ taxDetail.trade_no }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-user" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">认证姓名：</span><span class="flex1">{{ taxDetail.name }}</span></div>
          <!--          <div class="item flex_middle"><i class="el-input__icon el-icon-mobile-phone" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">手机号：</span><span class="flex1">{{ taxDetail.phone }}</span> </div>-->
          <div class="item flex_middle"><i class="el-input__icon el-icon-postcard" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">身份证号：</span><span class="flex1">{{ taxDetail.idcard }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-time" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">认证时间：</span><span class="flex1">{{ taxDetail.verify_time }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-coin" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">提现金额：</span><span class="flex1">￥{{ $formatCurrency(taxDetail.pay_amount) }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-remove-outline" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">预扣增值税：</span><span class="flex1">￥{{ $formatCurrency(taxDetail.vat_amount) }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-remove-outline" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">预扣附加税：</span><span class="flex1">￥{{ $formatCurrency(taxDetail.super_amount) }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-bell" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">个税税率：</span><span class="flex1">{{ taxDetail.iit_rate }} %</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-remove-outline" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">预扣个税：</span><span class="flex1">￥{{ $formatCurrency(taxDetail.iit_amount) }}</span></div>
          <div class="item flex_middle"><i class="el-input__icon el-icon-coin" style="height: 20px;color: #0080FF;top: -10px;position: relative;"></i><span class="label">实际到账金额：</span><span class="flex1">￥{{ $formatCurrency(taxDetail.received_price) }}</span></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="visibleTaxDetail = false">关 闭</el-button>
        </span>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import ZfTable from '@/components/ZfTable/CoreTable'
import UseGuide from '@/components/UseGuide'
import PriceRange from '@/components/priceRangeNew'
import column from './columns/list'
import paidListColumn from './columns/paidList'
import { getappIDList } from '@/api/common'
import { todoList, paidList, billDownload, taxDetail } from '@/api/pay'
import dayjs from 'dayjs'
import { getMchList } from '@/api/common'
import { get } from '@/utils/storage'
export default {
  name: 'List',
  components: {
    ZfTable,
    PriceRange,
    UseGuide
  },
  data() {
    return {
      tableData: [],
      queryForm: {
        order_id: '', // 客户订单号
        appid: '',
        openid: '',
        query_date: this.$route.query.date || dayjs().format('YYYY-MM-DD'),
        start_price: '',
        end_price: '',
        pay_status: '',
        pageSize: 10,
        page: 1,
        total: 0
      },
      activeName: '1',
      column,
      optionArr: [],
      appidArr: [],
      // 已完成
      paidListColumn,
      list: [],
      queryFormPaid: {
        order_id: '', // 任务编号
        appid: '',
        openid: '',
        query_date: dayjs().format('YYYY-MM-DD'),
        start_price: '',
        end_price: '',
        pay_status: '',
        // time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        // pay_start_time: '', // 支付时间
        // pay_end_time: '', // 支付时间
        trade_no: '', // 平台支付订单号
        mch_id: '',
        pageSize: 10,
        page: 1,
        total: 0
      },
      summaryPaid: {
        fail_sum: 0,
        success_sum: 0
      },
      mchArr: [],
      exportShow: true,
      showMoreSearch: true,
      visibleTaxDetail: false,
      taxDetail: false,
      showMoreSearchList: false
    }
  },
  mounted() {
    getMchList({ company_id: JSON.parse(get('userinfo')).company_id }).then(res => {
      if (res.code === 200) {
        this.mchArr = res.data
      }
    })
    getappIDList().then(res => {
      this.appidArr = res.data
    })
    this.query()
  },
  methods: {
    async query() {
      const res = await todoList(this.queryForm)
      if (res.code === 200) {
        this.tableData = res.data.data
        this.queryForm.total = res.data.total
      }
    },
    async queryList() {
      this.queryForm.page = 1
      this.query()
    },
    resetForm() {
      this.queryForm = {
        order_id: '', // 客户订单号
        appid: '',
        openid: '',
        query_date: this.$route.query.date || dayjs().format('YYYY-MM-DD'),
        start_price: '',
        end_price: '',
        pay_status: '',
        pageSize: 10,
        page: 1,
        total: 0
      }
      this.queryList()
    },
    handlePageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.queryForm.page = pageNum
      this.queryForm.pageSize = pageSize
      this.query()
    },
    handlePageChangePaid({ pageNum, pageSize, sorter: { prop, order }}) {
      this.queryFormPaid.page = pageNum
      this.queryFormPaid.pageSize = pageSize
      this.queryPaid()
    },
    nextDetail(row) {
      this.$router.push({
        path: '/task/task_detail',
        query: {
          work_number: row.work_number
        }
      })
    },
    async queryPaid() {
      const today = dayjs().format('HHmm')
      const choiceDay = dayjs(this.queryFormPaid.query_date).format('YYYYMMDD') + today
      const isToday = dayjs().format('YYYYMMDD') + today
      if (isToday > choiceDay) {
        this.exportShow = true
      } else if (isToday === choiceDay && today >= '1230') {
        this.exportShow = true
      } else {
        this.exportShow = false
      }
      const res = await paidList(this.queryFormPaid)
      if (res.code === 200) {
        this.list = res.data.list.data
        this.queryFormPaid.total = res.data.list.total
        this.summaryPaid = res.data.sum
      }
    },
    resetPaid() {
      this.queryFormPaid = {
        order_id: '', // 任务编号
        appid: '',
        openid: '',
        query_date: dayjs().format('YYYY-MM-DD'),
        start_price: '',
        end_price: '',
        pay_status: '',
        trade_no: '', // 平台支付订单号
        mch_id: '',
        pageSize: 10,
        page: 1,
        total: 0
      }
      this.queryPaidList()
    },
    async queryPaidList() {
      this.queryFormPaid.page = 1
      this.queryPaid()
    },
    async exportList() {
      if (this.list.length === 0) {
        this.$message('暂无导出数据')
        return
      }
      const query_date = dayjs(this.queryFormPaid.query_date).format('YYYYMMDD')
      const res = await billDownload({ bill_date: query_date })
      if (res.type !== 'application/json') {
        const blob = new Blob([res], { type: 'application/gz' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a') // 创建a标签
        link.href = url
        link.download = `${query_date}${'完成订单.gz'}`
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url) // 释放内存
      }
    },
    // 扣税详情
    async getTaxDetail(row) {
      this.taxDetail = {}
      const res = await taxDetail({ trade_no: row.trade_no })
      if (res.code === 200) {
        this.taxDetail = res.data
        this.taxDetail.trade_no = row.trade_no
        this.visibleTaxDetail = true
      }
    },
    handleClick(tab) {
      if (tab.name === '1') {
        this.query()
      } else {
        this.queryPaid()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.verify_box{
  .item{
    margin-bottom: 10px;
    img{
      width: 26px;
    }
    &:last-child{
      margin-bottom: 0;
    }
    .label{
      width: 100px;
      text-align: left;
      font-weight: 600;
      margin-left: 10px;
    }
  }
}
::v-deep{
  .el-dialog__body {
    padding: 10px 20px;
  }
  .withdraw{
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
      width: 150px;
    }
  }
}
</style>
